import React, { Component, createRef } from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import i18n from '../../../i18n';
import ReactTextareaAutocomplete from "@webscopeio/react-textarea-autocomplete";

import '@webscopeio/react-textarea-autocomplete/style.css';
const Item = ({ entity: { name, char } }) => <div>
    {`${name} -> ${char.length > 50 ? char.substring(0, 50) + "..." : char }`}
</div>;
const Loading = ({ data }) => <div>Carregando</div>;
/**
 * A basic text entry field, for reuse in different widgets.
 */
export default class TextEntryField  extends Component {

  constructor(props) {
   super(props);

    this.element = createRef();
  }

  // CTRL+Enter functions as Ok
  onKeyDown = evt => {
    if (evt.which === 13 && evt.ctrlKey) {
      this.props.onSaveAndClose();
    }
  }

  onKeyUp = evt => {
    if (evt.which === 46)
      evt.stopPropagation();
  }

  componentDidMount() {
    if (this.props.focus && this.element.current)
      this.element.current.focus({ preventScroll: true });
    }
  // Focus on render
  onRender = ref => {
    // Note: we could use this to set automatic focus (but leave this out for now)
  }

  render() {
    return (
        <>
            <ReactTextareaAutocomplete
                className="r6o-editable-text"
                value={this.props.content}
                dropdownStyle={{
                    zIndex: 9999,
                    maxHeight: 250,
                    minWidth: 400,
                    overflow: 'auto',
                }}
                ref={this.element
                  }
                loadingComponent={Loading}
                placeholder={this.props.placeholder || i18n.t('Add a comment...')}
                disabled={!this.props.editable}
                onChange={this.props.onChange}
                onKeyUp={this.props.onKeyUp}
                onKeyDown={this.onKeyDown}
                minChar={0}
                trigger={{
                    '/' : {
                    dataProvider: token => {
                        return fetch(this.props.endpoint + '?text=' + token)
                            .then(res => res.json())
                            .then(data => {
                                return data
                            })
                            .catch(err => {
                                return []
                            })
                    },
                    allowWhitespace: true,
                    component: Item,
                    output: (item, trigger) => item.char
                    }
                }}
            />
        </>
       /*
      <TextareaAutosize
        ref={this.element}
        className="r6o-editable-text"
        value={this.props.content}
        placeholder={this.props.placeholder || i18n.t('Add a comment...')}
        disabled={!this.props.editable}
        onChange={this.props.onChange}
        onKeyUp={this.onKeyUp}
        onKeyDown={this.onKeyDown} />
        */

    )
  }

}
